import axios from 'api/axios'
import { WebhookJsonDetailsI } from 'types'

export interface GetWebhookDetailsResponse {
	data: WebhookJsonDetailsI[]
}

/**
 * API call create a get the webhook details in case of vendor is PINNACLE
 * @param id string - client id
 * @returns GetWebhookDetailsResponse - Response object returned from the server
 */

const getWebhookDetails = async (
	id: string
): Promise<GetWebhookDetailsResponse> => {
	const response = await axios.get<GetWebhookDetailsResponse>(
		`v1/client/webhook/${id}`
	)
	return response.data
}
export default getWebhookDetails
